import { BABYLONJS_MODULE_OPTIONS_TOKEN, BabylonjsModuleOptions } from '@modules/babylonjs/src/BabylonjsModule';
import { BaseModule } from '@modules/core/src/injectable';

import { setAPIURL } from './API';

export class APIModule implements BaseModule {
  static readonly INJECTABLE_TOKEN = Symbol.for('APIModule');

  readonly api: {};

  constructor({
    [BABYLONJS_MODULE_OPTIONS_TOKEN]: options,
  }: {
    [BABYLONJS_MODULE_OPTIONS_TOKEN]?: BabylonjsModuleOptions;
  }) {
    setAPIURL(options?.apiEndpoint ?? '/');

    this.api = {};
  }

  dispose() {}
}
